import { render, staticRenderFns } from "./PeriodReward.vue?vue&type=template&id=60bbe5c9&scoped=true&"
import script from "./PeriodReward.vue?vue&type=script&lang=js&"
export * from "./PeriodReward.vue?vue&type=script&lang=js&"
import style0 from "./PeriodReward.vue?vue&type=style&index=0&id=60bbe5c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bbe5c9",
  null
  
)

export default component.exports